export default {
    name: 'Navn',
    tel: 'Telefon',
    save: 'Gem',
    confirm: 'Bekræft',
    cancel: 'Annuller',
    delete: 'Slet',
    complete: 'Fuldfør',
    loading: 'Indlæser...',
    telEmpty: 'Udfyld telefonnummer',
    nameEmpty: 'Udfyld navn',
    nameInvalid: 'Ugyldigt navnformat',
    confirmDelete: 'Er du sikker på, at du vil slette?',
    telInvalid: 'Ugyldigt telefonnummer',
    vanCalendar: {
        end: 'Slut',
        start: 'Start',
        title: 'Kalender',
        startEnd: 'Start/Slut',
        weekdays: ['Søn', 'Man', 'Tir', 'Ons', 'Tor', 'Fre', 'Lør'],
        monthTitle: (year, month) => `${year}/${month}`,
        rangePrompt: (maxRange) => `Vælg højst ${maxRange} dage`,
    },
    vanCascader: {
        select: 'Vælg',
    },
    vanContactCard: {
        addText: 'Tilføj kontaktoplysninger',
    },
    vanContactList: {
        addText: 'Tilføj ny kontakt',
    },
    vanPagination: {
        prev: 'Forrige',
        next: 'Næste',
    },
    vanPullRefresh: {
        pulling: 'Træk for at opdatere...',
        loosing: 'Slip for at opdatere...',
    },
    vanSubmitBar: {
        label: 'I alt：',
    },
    vanCoupon: {
        unlimited: 'Ubegrænset',
        discount: (discount) => `${discount * 10}% rabat`,
        condition: (condition) => `Mindst ${condition}`,
    },
    vanCouponCell: {
        title: 'Rabatkupon',
        tips: 'Ingen kuponer',
        count: (count) => `Du har ${count} kuponer`,
    },
    vanCouponList: {
        empty: 'Ingen kuponer',
        exchange: 'Byt',
        close: 'Luk',
        enable: 'Tilgængelig',
        disabled: 'Utilgængelig',
        placeholder: 'Kuponkode',
    },
    vanAddressEdit: {
        area: 'Område',
        postal: 'Postnummer',
        areaEmpty: 'Vælg modtageområde',
        addressEmpty: 'Adresse må ikke være tom',
        postalEmpty: 'Forkert postnummer',
        defaultAddress: 'Sæt som standardadresse',
        telPlaceholder: 'Telefon',
        namePlaceholder: 'Navn',
        areaPlaceholder: 'Område',
    },
    vanAddressEditDetail: {
        label: 'Adresse',
        placeholder: 'Adresse',
    },
    vanAddressList: {
        add: 'Tilføj ny adresse',
    },
};